import React from 'react';

/**
 * 위험도 배지. 규격: docs/design.md 6.6
 *
 * getRiskLevel() 이 돌려주는 { level, color } 중 level 문자열만 쓴다.
 * 색은 여기서 level 을 보고 토큰 클래스로 정한다 — 페이지마다 다른 color 값을 쓰지 않기 위해서다.
 * 임계값(어느 값이 위험인지)은 건드리지 않는다. 그건 각 페이지의 getRiskLevel 소관이다.
 *
 * <RiskBadge level="위험 (고혈압)" value={152} />         → [● 152 위험]
 * <RiskBadge level="정상" />                              → [● 정상]
 * <RiskBadge level="경고 (고혈당 주의)" value={131} short={false} /> → [● 131 경고 (고혈당 주의)]
 */

export function riskStatusKey(level) {
    if (!level) return 'none';
    const s = String(level);
    if (s.startsWith('정상')) return 'normal';
    if (s.startsWith('경고') || s.startsWith('주의')) return 'caution';
    if (s.startsWith('위험')) {
        // "위험 (저혈당)", "위험 (저혈압)", "위험 (저체중)" — 낮은 쪽 위험은 남색
        return /\(저/.test(s) ? 'danger-low' : 'danger';
    }
    if (s.startsWith('심각')) return 'danger';
    return 'none';
}

/** "경고 (고혈압 주의)" → "경고". 표 안에서 짧게 보일 때 쓴다. */
export function riskShortLabel(level) {
    if (!level) return '기록 없음';
    return String(level).split(' (')[0];
}

export default function RiskBadge({ level, value, short = true, title, className = '' }) {
    const key = riskStatusKey(level);
    const label = short ? riskShortLabel(level) : (level || '기록 없음');
    const hasValue = value !== null && value !== undefined && value !== '';
    return (
        <span
            className={`sds-badge sds-badge--${key} ${className}`.trim()}
            title={title || (hasValue ? `${value} · ${level}` : level)}
        >
            {hasValue && <b>{value}</b>}
            <span>{label}</span>
        </span>
    );
}
